var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';

import { Translate } from "../../../../../I18N";
import { InputField } from "../../../../Components/Forms";








const FormInput = (data, formProps) => {
  const { register, setValue, submitting, getFieldState } = formProps;
  const { error } = getFieldState(data.cell.getValue());
  const hasErrors = Boolean(error);
  const reset = () => setValue(data.cell.getValue(), '', { shouldDirty: true });
  const { onChange, onBlur, name, ref } = register(data.cell.getValue(), { required: true });

  return /*#__PURE__*/(
    _jsx("div", {}, void 0, /*#__PURE__*/
    React.createElement(InputField, {
      id: data.cell.getValue(),
      label: data.cell.row.original.language,
      hideLabel: true,
      disabled: submitting,
      clearFieldAction: reset,
      errorMessage: hasErrors ? /*#__PURE__*/_jsx(Translate, {}, void 0, "This field is required") : '',
      onChange: onChange,
      onBlur: onBlur,
      name: name,
      ref: ref }
    )
    ));

};

export { FormInput };